// extracted by mini-css-extract-plugin
export default {"title":"Q9z0F","controlsContainer":"K31tM","tablet":"p9G9X","control":"mr40w","nativeInput":"aEWLm","buttonsContainer":"UcAjd","button":"etwLx"};